export default (params) => ({
  trigger: {
    name: 'out_of_stock_entrance.click_reviews',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'read_reviews',
      params: {
        sub_feature: null,
      },
    },
  },
});
